import z from "zod/v4";

export const stringToHttpURL = z.codec(z.url({ protocol: /^https?$/ }), z.instanceof(URL), {
  decode: (urlString) => new URL(urlString),
  encode: (url) => url.href,
});
